import { createContext, ReactNode, useContext } from 'react';
import { AdminBootstrapDictionaries, AuthToken } from '../../api/types';
import { AdminTheme } from './theme';

interface AdminContextValue {
  authToken: AuthToken;
  currentUserId: number;
  dictionaries: AdminBootstrapDictionaries;
  onLogout: () => void;
  onThemeToggle: () => void;
  theme: AdminTheme;
}

const AdminContext = createContext<AdminContextValue | null>(null);

interface AdminProviderProps {
  authToken: AuthToken;
  children: ReactNode;
  dictionaries: AdminBootstrapDictionaries;
  onLogout: () => void;
  onThemeToggle: () => void;
  theme: AdminTheme;
}

export function AdminProvider({
  authToken,
  children,
  dictionaries,
  onLogout,
  onThemeToggle,
  theme,
}: AdminProviderProps) {
  const currentUserId = authToken.user.user_id;

  return (
    <AdminContext.Provider value={{ authToken, currentUserId, dictionaries, onLogout, onThemeToggle, theme }}>
      {children}
    </AdminContext.Provider>
  );
}

export function useAdminContext(): AdminContextValue {
  const context = useContext(AdminContext);

  if (context === null) {
    throw new Error('useAdminContext must be used inside AdminProvider.');
  }

  return context;
}
